import { css } from '@emotion/react';
import { media, tokens } from '@domain-group/fe-brary';

export const container = (hasReviews: boolean = false) => css`
  width: 100%;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr;
  gap: ${tokens.spacing.m};

  ${hasReviews &&
  css`
    ${media('>=desktop')} {
      grid-template-columns: 7fr 5fr;
    }
  `}
`;

export const sidebarWrapper = css`
  ${media('<desktop')} {
    padding-top: ${tokens.spacing.m};
    border-top: 1px solid ${tokens.colors.neutral.trim.default};
  }
`;
